import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const MeusDados = () => {
  const navigate = useNavigate();
  const [dados, setDados] = useState({
    nome_completo: "",
    telefone: "",
    email: "",
    usuario: "",
    senha_atual: "",
    nova_senha: "",
  });

  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log("Token JWT usado na tela Meus Dados:", token);

    if (!token) {
      setErro("Token ausente. Faça login novamente.");
      return;
    }

    axios
      .get("/api/usuarios/me", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setDados((prev) => ({ ...prev, ...res.data })))
      .catch((err) => {
        console.error("Erro ao carregar dados:", err.response?.data || err.message);
        setErro("Erro ao carregar dados do usuário.");
      });
  }, []);

  const handleChange = (e) => {
    setDados({ ...dados, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem("");
    setErro("");
    const token = localStorage.getItem("token");

    try {
      await axios.put("/api/usuarios/me", dados, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMensagem("Dados atualizados com sucesso.");
      setDados((prev) => ({ ...prev, senha_atual: "", nova_senha: "" }));
    } catch (error) {
      setErro(error.response?.data?.erro || "Erro ao atualizar dados.");
    }
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Meus Dados</h2>

      <form onSubmit={handleSubmit} noValidate>
        <div className="form-row">
          <div className="form-group" style={{ flex: 1 }}>
            <label>Nome Completo</label>
            <input
              type="text"
              name="nome_completo"
              value={dados.nome_completo}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group" style={{ width: "180px", flex: "none" }}>
            <label>Telefone</label>
            <input
              type="text"
              name="telefone"
              value={dados.telefone}
              onChange={handleChange}
            />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={dados.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group" style={{ width: "220px", flex: "none" }}>
            <label>Usuário</label>
            <input
              type="text"
              name="usuario"
              value={dados.usuario}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <hr className="linha-divisoria" />

        <div className="form-row">
          <div className="form-group" style={{ width: "220px" }}>
            <label>Senha Atual</label>
            <input
              type="password"
              name="senha_atual"
              value={dados.senha_atual}
              onChange={handleChange}
            />
          </div>
          <div className="form-group" style={{ width: "220px" }}>
            <label>Nova Senha</label>
            <input
              type="password"
              name="nova_senha"
              value={dados.nova_senha}
              onChange={handleChange}
            />
          </div>
        </div>

        {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
        {erro && <p className="mensagem-erro">{erro}</p>}

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Salvar Alterações
          </button>
        </div>
      </form>
    </div>
  );
};

export default MeusDados;
